<!-- start banner Area -->
<section class="top-banner">
  <div class="top-banner-img" style="">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 style="padding: 20px 0px 10px 0px !important;
    font-size: 40px !important;
    text-align: center !important;"> Candidats au poste de : <br>
            <span class="mb-2" style="font-size: 22px">{{ job.getLibelle() }}</span>
          </h1>
          <div class="serach-form-area form-wrap">
            <div class="row justify-content-center mb-1 p-2">
              <div class="col-lg-9">
                <div class="row ">
                  <div class="col-lg-4 form-cols">
                    <div class="default-select" id="default-selects2">
                      <select class="form-control" [(ngModel)]="eligibility_rate" style="height: 50px !important;">
                        <option value="">TAUX D'ELIGIBILITE...</option>
                        <option value="less_than_50">Inférieur à 50%</option>
                        <option value="between_50_and_75">Entre 50% et 75%</option>
                        <option value="more_than_75">Supérieur ou égal à 75%</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3 form-cols">
                    <div class="default-select" id="default-selects">
                      <select class="form-control" [(ngModel)]="level_of_study" style="height: 50px !important;">
                        <option value="">NIVEAU D'ETUDE...</option>
                        <option value="Secondaire">Secondaire</option>
                        <option value="Terminal">Terminal</option>
                        <option value="Formation professionnelle">Formation professionnelle</option>
                        <option value="Baccalauréat">Baccalauréat</option>
                        <option value="Universitaire sans diplôme">Universitaire sans diplôme</option>
                        <option value="BAC + 2">BAC + 2</option>
                        <option value="Licence(BAC + 3)">Licence(BAC + 3)</option>
                        <option value="Master 1(BAC + 4)">Master 1(BAC + 4)</option>
                        <option value="Master 2(BAC + 5)">Master 2(BAC + 5)</option>
                        <option value="Doctorat(BAC + 7)">Doctorat(BAC + 7)</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-4 mb-3 form-cols">
                    <div class="default-select" id="default-selects2">
                      <select class="form-control" [(ngModel)]="years_of_experience" style="height: 50px !important;">
                        <option value="">ANNEES D'EXPERIENCES...</option>
                        <option value="Sans experience">Sans experience</option>
                        <option value="Moins d'un an">Moins d'un an</option>
                        <option value="1 à 2ans">1 à 2ans</option>
                        <option value="3 à 5ans">3 à 5ans</option>
                        <option value="6 à 10ans">6 à 10ans</option>
                        <option value="Plus de 10ans">Plus de 10ans</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-lg-4 mb-3 form-cols">
                    <div class="default-select" id="default-selects2">
                      <select class="form-control" id="position_level" [(ngModel)]="position_level"
                        style="height: 50px !important;">
                        <option value="">NIVEAU DE POSTE...</option>
                        <option value="Stagiaire/Etudiant">Stagiaire/Etudiant</option>
                        <option value="Jeune diplomé">Jeune diplomé</option>
                        <option value="Débutant/Junior">Débutant/Junior</option>
                        <option value="Confirmé/Experimenté">Confirmé/Experimenté</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-4 form-cols">
                    <div class="default-select" id="default-selects">
                      <select class="form-control" [(ngModel)]="training" style="height: 50px !important;">
                        <option value="">FORMATION...</option>
                        <option value="{{ training.getId() }}" *ngFor="let training of trainingList">{{
                          training.getLibelle() }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-4 form-cols">
                    <div class="default-select" id="default-selects2">
                      <select class="form-control" [(ngModel)]="language_level" style="height: 50px !important;">
                        <option value="">NIVEAU DE LANGUE...</option>
                        <option value="{{ language['id'] }}" *ngFor="let language of languageList">{{
                          language['libelle']
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row justify-content-center mb-2 ">
              <div class="col-lg-3 form-cols">
                <button type="button" class="btn btn-submit pt-2 pb-2" (click)="searchCandidatesApplyJob()">
                  <span class="lnr lnr-magnifier"></span> Rechercher
                </button>
              </div>
            </div>
          </div>
          <div class="row justify-content-end">
            <p class="text-white link-nav"><a *ngIf="userType == 'entreprise'" routerLink="/mes-offres-emploi"
                style="color: #ff5a00 !important">Mes Offres d'emploi </a> <a *ngIf="userType == 'admin'"
                routerLink="/admin/offres-emploi/0" style="color: #ff5a00 !important">Toutes les offres d'emploi
              </a><span class="lnr lnr-arrow-right"></span> <span> Candidatures</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<br><br>

<!-- End banner Area -->

<!-- Start post Area -->
<section class="post-area section-gap">
  <div class="container">


    <!-- Loading -->
    <div class="row d-flex justify-content-center mb-4" *ngIf="isLoading">
      <span style="color: red">Chargement...</span>
    </div>

    <!-- Button to export data -->
    <div class="container">
      <div class="row d-flex flex-custom  mb-2">
        <span style="color: green">{{ candidatesJobsApply.length }} enregistrement (s) trouvé(s)</span>

      </div>
      <div class="mb-2">
        <button class="btn btn-success ml-4 mb-4" style="float: right;" (click)="exportRepport()">Rapport de
          présélection</button>
        <button class="btn btn-danger mb-4" style="float: right;" (click)="exportToExcel()">Exporter Excel</button>
      </div>
    </div>







    <!-- Nb record find -->
    <!-- <div class="row d-flex justify-content-center mb-4">

    </div> -->

    <!-- Nb record selected -->
    <div class="row d-flex justify-content-center mb-4" *ngIf="candidateJobApplySelected.length > 0">
      <span style="color: red">{{ candidateJobApplySelected.length }} enregistrement (s) selectionné(s)</span>
    </div>

    <div class="container" style="width: 100%; overflow: auto;">
      <div class="row post-list mb-5">
        <table id="candidates" class="table table-bordered table-hover" style="width:100%">
          <thead>
            <tr>
              <th><input id="checkbox_all" type="checkbox" (click)="selectedRow('all', 'checkbox')"></th>
              <th>Taux d'éligibilité</th>
              <th>Nom & prénom</th>
              <th>Sexe</th>
              <th>Age</th>
              <th>Email</th>
              <th>Téléphone</th>
              <!-- <th>Profession</th>
              <th>Années d'exp.</th>
              <th>Niveau de poste</th> -->
              <th>Dossier</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let candidates of candidatesJobsApply" (click)="selectedRow(candidates.getId(), 'row')">
              <td><input id="checkbox_{{ candidates.getId() }}" type="checkbox" disabled></td>
              <!-- EligibilityRate - Start -->
              <td *ngIf="candidates.getEligibilityRate() < 50 ; else firstBlock "
                style="text-align: center; color: white; background-color: red;">{{ candidates.getEligibilityRate() }} %
              </td>
              <ng-template #firstBlock>
                <td *ngIf="candidates.getEligibilityRate() < 75; else secondBlock "
                  style="text-align: center; color: black; background-color: yellow;">
                  {{ candidates.getEligibilityRate() }} %</td>
              </ng-template>
              <ng-template #secondBlock>
                <td style="text-align: center; color: white; background-color: green;">{{
                  candidates.getEligibilityRate() }} %</td>
              </ng-template>
              <!-- EligibilityRate - Start -->

              <td>{{ candidates.getCandidates().getFirstName() }} {{ candidates.getCandidates().getLastName() }}</td>
              <td>{{ candidates.getCandidates().getGender() }}</td>

              <!-- Age - Start -->
              <td *ngIf="calculateAge(candidates.getCandidates().getDateBirth()) < job.getMaxAge(); else ageMoreThan "
                style="text-align: center; color: white; background-color: green;">
                {{ calculateAge(candidates.getCandidates().getDateBirth()) }} ans</td>
              <ng-template #ageMoreThan>
                <td style="background: red; color: white; text-align: center;">
                  {{ calculateAge(candidates.getCandidates().getDateBirth()) }} ans</td>
              </ng-template>
              <!-- Age - Start -->

              <td>{{ candidates.getCandidates().getEmail() }}</td>
              <td>{{ candidates.getCandidates().getPhone1() }} / {{ candidates.getCandidates().getPhone2() }}</td>
              <!-- <td>{{ candidates.getCandidates().getCandidatesProfiles().getProfessions().getLibelle() }}</td>
              <td>{{ candidates.getCandidates().getCandidatesProfiles().getYearsOfExperience() }}</td>
              <td>{{ candidates.getCandidates().getCandidatesProfiles().getPositionLevel() }}</td> -->
              <td><button class="btn" style="background-color: #00027D; color: white;"
                  (click)="getCandidateProfile(candidates.getCandidates().getId())">Voir</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
<!-- End post Area -->